import React from "react";
import { toastr } from "react-redux-toastr";
import i18n from "i18n";
import { UNDO_MARK_TOAST_HIDDEN, UNDO_TOAST_TIMEOUT_MS, UNDO_UPDATE_TOAST_ID } from "utils/undo/constants";
import { createUndoId } from "utils/undo/createUndoId";
import { isUndoToastsEnabled } from "utils/undo/isUndoToastsEnabled";
import UndoToastAction from "utils/toast/UndoToastAction";

export function showSuccessToast({
	title,
	message,
	timeOut = UNDO_TOAST_TIMEOUT_MS,
}) {
	toastr.success(title || i18n.t("common.success"), message, {
		timeOut,
		id: createUndoId("success"),
	});
}

export function showToastForCommand({
	dispatch,
	scope,
	command,
	isActive,
	onUndo,
}) {
	const message = i18n.t(command.messageKey, command.messageParams);
	const toastId = createUndoId("toast");
	const options = {
		id: toastId,
		timeOut: UNDO_TOAST_TIMEOUT_MS,
		// The card itself must not undo or dismiss. Only Deshacer undoes, and the X dismisses.
		closeOnToastrClick: false,
		disableCloseButtonFocus: true,
		preventDuplicates: false,
		onHideComplete: () => {
			dispatch({
				type: UNDO_MARK_TOAST_HIDDEN,
				payload: { scope, commandId: command.id },
			});
		},
	};

	if (isActive && isUndoToastsEnabled() && onUndo) {
		options.className = "toastr--with-action";
		options.component = <UndoToastAction onUndo={onUndo} />;
		toastr.success("", message, options);
	} else {
		toastr.success(i18n.t("common.success"), message, options);
	}

	dispatch({
		type: UNDO_UPDATE_TOAST_ID,
		payload: { scope, commandId: command.id, toastId },
	});

	return toastId;
}

export function showUndoableSuccessToast({
	dispatch,
	scope,
	command,
	isActive,
	onUndo,
}) {
	if (!command) {
		return null;
	}

	return showToastForCommand({
		dispatch,
		scope,
		command,
		isActive: Boolean(isActive),
		onUndo,
	});
}

export function refreshScopeSuccessToasts({
	dispatch,
	getState,
	scope,
	selectActiveUndoCommand,
	selectVisibleUndoCommands,
	createOnUndo,
}) {
	if (!isUndoToastsEnabled()) {
		return;
	}

	const state = getState();
	const activeCommand = selectActiveUndoCommand(state, scope);
	const visibleCommands = selectVisibleUndoCommands(state, scope);

	visibleCommands.forEach((command) => {
		if (command.toastId) {
			toastr.remove(command.toastId);
		}

		showToastForCommand({
			dispatch,
			scope,
			command,
			isActive: activeCommand?.id === command.id,
			onUndo: createOnUndo(command),
		});
	});
}
